import { createContext } from 'react';

export const OfflineModifiersContext = createContext({});

export default OfflineModifiersContext;
